import React from "react";
import "../styles/Courses.css";

const courses = [
  {
    src: "/Nurseimage1.webp",
    alt: "GNM Nursing",
    heading: "GNM (General Nursing & Midwifery)",
    institution: "Sarojini College of Nursing, Dhule",
    info: "Strong foundations in patient care, nursing management, and community health, with hands-on clinical experience and compassionate skill development."
  },
  {
    src: "/DMLTImage1.webp",
    alt: "DMLT Paramedical",
    heading: "DMLT (Diploma in Medical Laboratory Technology)",
    institution: "Sarojini Institute, Dhule",
    info: "Comprehensive training in clinical laboratory techniques and medical diagnostics, preparing for essential roles in healthcare laboratories."
  },
  {
    src: "/Physiotherapyphoto1.webp",
    alt: "Physiotherapy",
    heading: "Physiotherapy",
    institution: "Sarojini Institute, Dhule",
    info: "Prepares students for careers in rehabilitation and physical therapy, focusing on patient mobility, recovery, and modern therapeutic practices."
  }
];

function Courses() {
  return (
    <div className="courses-main">
      <div className="courses-container">
        <h1>Courses Offered</h1>
        <div className="courses-list">
          {courses.map((course, idx) => (
            <div className="course-card" key={idx}>
              <img src={course.src} alt={course.alt} className="course-img" />
              <div className="course-info">
                <div className="course-heading">{course.heading}</div>
                <div className="course-inst">{course.institution}</div>
                <div className="course-desc">{course.info}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
export default Courses;